import {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {useDebounce} from "../../../helpers/useDebounce";
import { ISorting } from "../../../types/generalTypes";
import {createGetUsersQuery} from "../../../helpers/createGetUsersQuery";
import {getUsers, setPageNumber} from "../usersSlice";


export const useSortingAndSearch = () => {
    const [searchValue, setSearchValue] = useState<string | null>(null);
    const [sorting, setSorting] = useState<ISorting>({
        criteria: null,
        isAscending: true
    });
    const {itemsPerPage, pageNumber} = useAppSelector((state) => state.players);
    const dispatch = useAppDispatch();


    const handleSorting = (criteria: string): void => {
        if (criteria === sorting.criteria) {
            setSorting({
                criteria,
                isAscending: !sorting.isAscending
            })
        } else {
            setSorting({
                criteria,
                isAscending: true
            })
        }
    }


    const getSortedItems = () => {
        if (searchValue === null && !sorting.criteria) {
            return
        }

        const queryParams = createGetUsersQuery(
            pageNumber,
            itemsPerPage,
            sorting,
            searchValue
        )
        dispatch(getUsers(queryParams));
        dispatch(setPageNumber(1))
    }

    useDebounce(getSortedItems, [sorting, searchValue], 500);

    return {sorting, searchValue, handleSorting, setSearchValue}
}
